export const APP_COLOR = {

    APP_SECONDARY_COLOR : '#4485be',
    ONLINE_BADGE_COLOR : '#44b700',
    SECONDARY_BUTTON : '#1876F2',
    RIGHT_IMPORT_MSG_COLOR: 'rgb(234 234 234)',
    RIGHT_IMPORT_MSG_ATTACHMENT_COLOR : 'rgb(81 81 81)'
};